const requireFile = require.context(
  // The relative path of the folder
  '/',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base filenames and ignore index.js
  /\/(?!index\.js$)[a-z]\w+[a-z](?:-[a-z]+)?\.js$/

)

requireFile.keys().forEach(fileName => {
  requireFile(fileName)
})
